<template>
<div id="home">
    <Banner />
	<ServiceCards />
	<Carousel />
</div>
</template>

<script>
import Banner from '@/components/Banner.vue';
import ServiceCards from '@/components/ServiceCards.vue';
import Carousel from '@/components/Carousel.vue';

export default {
    name: 'app',
	components: {
		Banner,
        ServiceCards,
		Carousel
	},
}
</script>